import axios from 'axios';
import { IAnnouncementModel } from 'entities/Announcement/Announcement.models';

const basePath = 'announcements';

export const announcementTransport = {
  // storeId optional: guests without a selected store get "All stores" announcements.
  getActiveAnnouncements: (storeId?: string): Promise<IAnnouncementModel[]> =>
    axios.get(`${basePath}/store-active`, { params: storeId ? { storeId } : undefined }),
};
